/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { PureComponent } from 'react';
import { object } from 'prop-types';
import mbpLogger from 'mbp-logger';
import { Helmet } from 'react-helmet';
// Render Wyng content on the page
//
// Wyng is used to inject social media content into a page.
// It can manage signup forms for events and social-sourced images.
//
// passing the wyng_id and wyng_token is all that is needed.
// the script that injects the Wyng content resides in Tealium
//
// Floral brands handle the script from cms NOT Tealium

export class Wyng extends PureComponent {
    render() {
        const { data } = this.props;

        if (data?.reference?.[0]?.wyng_id && data?.reference?.[0]?.wyng_token) {
            return (
                <>
                    {data?.reference?.[0]?.heading && <h1>{data.reference[0].heading}</h1>}
                    <div style={{ width: '100%', margin: '0 auto' }} id="wyng-experience" data-wyng-id={data.reference[0].wyng_id} data-wyng-token={data.reference[0].wyng_token} />
                    <Helmet>
                        <script src={
                            // eslint-disable-next-line no-nested-ternary
                            data?.wyng_script_source ? data.wyng_script_source : data?.reference?.[0]?.wyng_script_source ? data.reference[0].wyng_script_source : null
                        }
                        />
                    </Helmet>

                </>
            );
        }
        mbpLogger.logDebug({
            message: `Wyng module called but did not pass valid data: ${data}`,
        });
        return <p> This Wyng content ({data?.reference?.[0]?.title}) cannot be loaded. Please double-check the id and token values. </p>;
    }
}

Wyng.propTypes = {
    data: object.isRequired,
};

export default Wyng;
